export default "__VITE_ASSET__Cr1dUI6c__"